var map = {
	"./arrow-down-blue.svg": 535,
	"./arrow-down-grey.svg": 536,
	"./arrow-right-white.png": 537,
	"./arrow-right.svg": 538,
	"./blue-loader.svg": 230,
	"./brain-chair.gif": 539,
	"./buy-icon.png": 192,
	"./change.png": 540,
	"./changeArrow.png": 231,
	"./changeArrow.svg": 541,
	"./circle-grey.svg": 542,
	"./circle.svg": 543,
	"./closeMenu.png": 544,
	"./coinbaseWalletIcon.svg": 155,
	"./data1.png": 545,
	"./data2.png": 546,
	"./dropdown-blue.svg": 547,
	"./dropdown.svg": 548,
	"./dropup-blue.svg": 549,
	"./erc.png": 550,
	"./ethereum-logo.png": 551,
	"./fold.svg": 552,
	"./fortmaticIcon.png": 156,
	"./knodata.png": 553,
	"./link.svg": 554,
	"./liquidity.png": 232,
	"./logo.png": 555,
	"./logo.svg": 121,
	"./magnifying-glass.svg": 556,
	"./menu.png": 557,
	"./menu.svg": 558,
	"./metamask.png": 233,
	"./mobile-logo.png": 559,
	"./mobile-swapBodyBg.png": 234,
	"./noise-color.png": 560,
	"./options-icon.png": 193,
	"./pepe-left.png": 561,
	"./plus-blue.svg": 562,
	"./plus-grey.svg": 563,
	"./portisIcon.png": 157,
	"./question-mark.svg": 564,
	"./question.svg": 565,
	"./sideicon.png": 235,
	"./spinner.svg": 566,
	"./swapBg.jpg": 154,
	"./swapBg.png": 567,
	"./swapBodyBg.png": 236,
	"./swapContentbox1.png": 237,
	"./swapContentbox3.png": 238,
	"./tab1.png": 317,
	"./tab2.png": 318,
	"./tab3.png": 319,
	"./tab4.png": 239,
	"./tab5.svg": 240,
	"./tok-logo.png": 568,
	"./tok.png": 187,
	"./token-list/lists-dark.png": 241,
	"./token-list/lists-light.png": 242,
	"./token-list/token1.png": 569,
	"./token-list/token10.png": 570,
	"./token-list/token2.png": 571,
	"./token-list/token3.png": 572,
	"./token-list/token4.png": 573,
	"./token-list/token5.png": 574,
	"./token-list/token6.png": 575,
	"./token-list/token7.png": 576,
	"./token-list/token8.png": 577,
	"./token-list/token9.png": 578,
	"./trc.png": 579,
	"./trustWallet.png": 580,
	"./trx.png": 581,
	"./walletConnectIcon.svg": 158,
	"./x.svg": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;